// extracted by css-extract-rspack-plugin
export default {"group":"UkQ_SyxkkAEs7jbU","default":"AEN7XCc8Y4EpHTvC DXrqAkuZnuI0A_VU","elevated":"rSgsjsWFGNg_Abcp"};